import { useTheme } from '@mui/system';

interface PraiseIconProps {
  height?: number;
  width?: number;
  fill?: string;
}

export const PraiseIcon = ({
  height = 32,
  width = 32,
  fill,
}: PraiseIconProps) => {
  const theme = useTheme();
  const fillColor = fill || theme.palette.category.praise;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
    >
      <title>Praise Icon</title>
      <path
        d="M23.3664 30.5333H9.29971V11.1667L18.433 2L21.233 4.5C21.4747 4.72509 21.6796 5.02581 21.8476 5.40217C22.0157 5.7785 22.0997 6.17867 22.0997 6.60267V6.73333L20.6997 11.1667H27.3664C28.553 11.1667 29.6053 11.6311 30.523 12.56C31.4408 13.4889 31.8997 14.5356 31.8997 15.7V16.4479C31.8997 16.6382 31.8775 16.8616 31.833 17.1181C31.7886 17.3746 31.7219 17.5908 31.633 17.7667L27.2997 28C27.0108 28.7111 26.4909 29.3111 25.74 29.8C24.989 30.2889 24.1978 30.5333 23.3664 30.5333ZM6.63304 11.1667V30.5333H0.699707V11.1667H6.63304Z"
        fill={fillColor}
      />
    </svg>
  );
};
